export class PlatexUserAlert {
  public id: number = 0;
  public userId: string = null;
  public term: string = '';
  public dateAdded: Date = new Date();
  public status: string = 'active';

  public registrationStyle: string = '';
  public budget: string = '';
  public saleType: string;
}
